<template>
  <div class="bone-list">
    <button class="button--create" @click="handleCreateClick">
      {{$t('editor.bone.create')}}
    </button>
    <select multiple="1" size="4" name="bones" @change="handleSelectionChange" v-if="cropData">
      <option v-for="(current, index) in cropData.bones" :key="current.id" :selected="selection.bones.find((currentIndex) => index === currentIndex) !== null">
        {{current.name}}
      </option>
    </select>
  </div>
</template>

<style lang="scss" scoped>
.button--create {
  margin-bottom: 1rem;
}
</style>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      cropData: (state) => state.crop.data,
      selection: (state) => state.editor.selection
    })
  },
  methods: {
    ...mapMutations({
      createBone: 'crop/createBone'
    }),
    ...mapActions({
      select: 'editor/select'
    }),
    handleCreateClick (e) {
      this.createBone()
    },
    handleSelectionChange (e) {
      this.select({
        name: e.target.name,
        selection: Array.from(e.target.selectedOptions).map((option) => option.index)
      })
    }
  }
}
</script>
